import type { GroupConfig } from '../types/pie-chart.config.js';

/**
 * Grouping slot component.
 */
export const Grouping = (props: GroupConfig) => null;

Grouping['displayName'] = 'PieChart.Grouping';
